(function () {
  const STORAGE_KEY = "framespace_pinned_tools_v1";

  function readPinned() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writePinned(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function isWebAppItem(el) {
    return el && el.matches && el.matches('.appSidebar__group .appSidebar__item[data-pin-id]');
  }

  function createPinnedClone(original) {
    // Clone link so it behaves like normal nav
    const clone = original.cloneNode(true);

    // Ensure pinned clone is marked pinned
    clone.classList.add("is-pinned");

    // The pin button on pinned items becomes "unpin"
    const btn = clone.querySelector("[data-pin-btn]");
    if (btn) {
      const label = original.getAttribute("data-pin-label") || "tool";
      btn.setAttribute("aria-label", `Unpin ${label}`);
      btn.setAttribute("data-pin-action", "unpin");
    }

    return clone;
  }

  function markOriginalPinnedStates(root, pinnedIds) {
    const items = root.querySelectorAll('.appSidebar__item[data-pin-id]');
    items.forEach((item) => {
      const id = item.getAttribute("data-pin-id");
      const btn = item.querySelector("[data-pin-btn]");
      const isPinned = pinnedIds.includes(id);

      item.classList.toggle("is-pinned", isPinned);

      if (btn) {
        const label = item.getAttribute("data-pin-label") || "tool";
        btn.setAttribute("data-pin-action", isPinned ? "unpin" : "pin");
        btn.setAttribute("aria-label", `${isPinned ? "Unpin" : "Pin"} ${label}`);
      }
    });
  }

  function renderPinned(root) {
    const pinnedIds = readPinned();

    const pinnedGroup = root.querySelector("[data-pinned-group]");
    const pinnedList = root.querySelector("[data-pinned-list]");
    const pinnedDivider = root.querySelector("[data-pinned-divider]");

    if (!pinnedGroup || !pinnedList || !pinnedDivider) return;

    // Clear pinned list
    pinnedList.innerHTML = "";

    if (!pinnedIds.length) {
      pinnedGroup.hidden = true;
      pinnedDivider.hidden = true;
      markOriginalPinnedStates(root, pinnedIds);
      return;
    }

    // Map originals by id
    const originals = Array.from(root.querySelectorAll('.appSidebar__item[data-pin-id]'));
    const byId = new Map(originals.map(el => [el.getAttribute("data-pin-id"), el]));

    // Build pinned in saved order
    pinnedIds.forEach((id) => {
      const original = byId.get(id);
      if (!original) return;
      pinnedList.appendChild(createPinnedClone(original));
    });

    pinnedGroup.hidden = false;
    pinnedDivider.hidden = false;

    markOriginalPinnedStates(root, pinnedIds);
  }

  function togglePin(root, id) {
    const pinnedIds = readPinned();
    const idx = pinnedIds.indexOf(id);

    if (idx >= 0) pinnedIds.splice(idx, 1);
    else pinnedIds.unshift(id); // newest pinned goes top

    writePinned(pinnedIds);
    renderPinned(root);
  }

  function initPins() {
    const sidebar = document.querySelector(".appSidebar");
    if (!sidebar) return;

    // Initial render
    renderPinned(sidebar);

    // Delegate clicks (pin buttons exist on originals and pinned clones)
    sidebar.addEventListener("click", (e) => {
      const btn = e.target.closest && e.target.closest("[data-pin-btn]");
      if (!btn) return;

      const item = btn.closest(".appSidebar__item");
      if (!item) return;

      // Stop navigation (because the button is inside a link)
      e.preventDefault();
      e.stopPropagation();

      const id = item.getAttribute("data-pin-id");
      if (!id) return;

      togglePin(sidebar, id);
    });
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPins);
  } else {
    initPins();
  }
})();
/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */